import { API_PATH } from "../utils/config";
import { SIGNUP_TIMEOUT_MS } from "./signupTimeout";

/**
 * Issue the account-creation request.
 *
 * Extracted from `useSignup` so the one thing that matters about it -- that
 * the request is BOUNDED -- can be asserted without mounting a react-query
 * provider. Mirrors `./postLogin.js`. A hung signup is the silent failure
 * documented in ./signupTimeout.js.
 *
 * @param {{post: Function}} api the axios instance
 * @param {object} data the signup payload
 * @returns {Promise} the axios promise
 */
export function postSignup(api, data) {
  return api.post(API_PATH.SIGN_UP, data, { timeout: SIGNUP_TIMEOUT_MS });
}
